import 'css-chunksrc/client/pages/documentsPage/reportsPage/styles.scss';export default {
  "reportsPage": "_reportsPage_13bir_1",
  "filters": "_filters_13bir_9",
  "main": "_main_13bir_17",
  "list": "_list_13bir_24",
  "reportsList": "_reportsList_13bir_32",
  "buttonBox": "_buttonBox_13bir_38",
  "button": "_button_13bir_38",
  "exportButton": "_exportButton_13bir_57"
};